import { TeaserData } from "@app/types/ServerCustomContext";
import { TechAwardsHighlightsApiResponse } from "@app/types/ServerCustomContext";
import {
  Ads,
  Button,
  Dropdown,
  ResponsiveImage,
  Typography,
} from "@sphtech/dmg-design-system";
import cx from "classnames";
import { useState } from "react";
import useSWR from "swr";

import placeholders from "../placeholders";
import styles from "./TechAwardsHighlights.module.css";

type Props = {
  contentListId: string;
};

export default function TechAwardsHighlightsContent({ contentListId }: Props) {
  const { Heading } = Typography;
  const [filterValue, setFilterValue] = useState("");

  const contentListData = useSWR<TechAwardsHighlightsApiResponse>(
    `/_plat/api/techawards/highlights?id=${contentListId}`,
  );

  let teasers: TeaserData[] = [];
  let viewAllUrl = "";

  const techAwardsOptions = contentListData.data?.results || [];
  const filterOptions = techAwardsOptions.map((option) => ({
    label: option.title || "",
    value: option.tag || "",
  }));

  // Find the selected teasers and URL
  const selectedOption = techAwardsOptions.find(
    (option) => option.tag === filterValue,
  );

  if (selectedOption) {
    teasers = selectedOption.teasers;
    viewAllUrl = selectedOption.tagUrl || "";
  } else {
    // Default: Use the first option if one exists
    const defaultOption = techAwardsOptions[0];
    if (defaultOption) {
      teasers = defaultOption.teasers;
      viewAllUrl = defaultOption.tagUrl || "";
    }
  }

  return (
    <section className={cx(styles.bodyContainer, styles.highlightsContainer)}>
      <Heading.SubHeading>Highlights</Heading.SubHeading>

      <div className={styles.highlightsFilter}>
        <div className={styles.highlightsFilterLabel}>Filter By:</div>
        <Dropdown
          label=""
          name="brands"
          id="brands_select"
          value={filterValue}
          options={filterOptions}
          onChange={(event) => {
            setFilterValue(event.target.value);
          }}
        />
      </div>
      <div className={styles.highlightsItemsContainer}>
        <div className={styles.highlightsItems}>
          {teasers.map((teaser, key) => (
            <a key={key} className={styles.highlightsItem} href={teaser.path}>
              <ResponsiveImage
                {...(teaser.image?.crops.landscape || placeholders.landscape)}
                errorSrc={placeholders.landscape.src}
              />
              <Heading.SubHeading3>{teaser.title}</Heading.SubHeading3>
            </a>
          ))}
        </div>
        <div className={styles.highlightsItemsSidebar}>
          <Ads.AdsSideBarDesktop />
        </div>
      </div>
      <div className={styles.highlightsViewAll}>
        <Button variant="secondary" href={viewAllUrl}>
          View All
        </Button>
      </div>
      <Ads.AdsSideBarMobile />
    </section>
  );
}
